import { inject, InjectionToken, Provider } from '@angular/core';
import { ORGANIZATION_SITE_LIST_SIGNAL_STORE } from '../signal-store/site-list.signal.store';
import { SiteListSignalState } from '../../types';

export const SITE_LIST_TOKEN = new InjectionToken<SiteListSignalState>(
  'Organization Site List',
);

export const SITE_LIST_PROVIDER: Provider = {
  provide: SITE_LIST_TOKEN,
  useClass: ORGANIZATION_SITE_LIST_SIGNAL_STORE,
};

export function organizationSiteListTokenizer() {
  return inject(SITE_LIST_TOKEN);
}
